import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Schedule } from "../../server/milestone/model";
import { getSchedulesByprogram } from "../app/api";
import { AppThunk } from "../app/store";
import { createNotificationDefinition } from "../notification/notificationConnector";

export interface ProgramInfo {
  programId: string;
  programName: string;
}

interface MilestoneScheduleTableState {
  loading: boolean;
  program?: ProgramInfo;
  schedules: Schedule[];
}

const initialState: MilestoneScheduleTableState = {
  loading: true,
  schedules: [],
};

const appSlice = createSlice({
  name: "asinMarketplaceBaselineMilestoneScheduleReducer",
  initialState,
  reducers: {
    setProgram: (state, action: PayloadAction<ProgramInfo | undefined>) => {
      state.program = action.payload;
      state.loading = true;
      state.schedules = [];
    },
    setSchedules: (state, action: PayloadAction<Schedule[]>) => {
      state.schedules = action.payload;
      state.loading = false;
    },
  },
});

export const { setProgram, setSchedules } = appSlice.actions;
export default appSlice.reducer;

export const fetchMilestoneSchedules =
  (program: ProgramInfo): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setProgram(program));
      return await getSchedulesByprogram(program.programId).then((schedules) =>
        dispatch(setSchedules(schedules))
      );
    } catch (err: any) {
      dispatch(
        createNotificationDefinition(
          "error",
          "Get Schedules By Program Error",
          true,
          `Error fetching Schedules: ${err.toString()}`
        )
      );
    }
  };
